import React, { useState, useEffect } from 'react';

export const TimeTracker = ({ onTimerUpdate }) => {
  const [timeInSeconds, setTimeInSeconds] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      setTimeInSeconds(prevTime => {
        const newTime = prevTime + 1;
        
        // Check if the prop is a function before calling it
        if (typeof onTimerUpdate === 'function') {
          // Execute the function passed from the parent, passing the current time
          onTimerUpdate(newTime);
        }
        return newTime;
      });
    }, 1000);

    return () => clearInterval(intervalId);
  }, []); // The effect runs only once on mount

  // Helper function to format the time into HH:MM:SS
  const formatTime = (totalSeconds) => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    // Use padStart to ensure two-digit formatting
    const pad = (num) => String(num).padStart(2, '0');

    return `${pad(hours)}:${pad(minutes)}:${pad(seconds)}`;
  };

  return (
    <div className="text-red-500">
      <b>Time </b> {formatTime(timeInSeconds)}
    </div>
  );
}